











import { Component, Prop } from 'vue-property-decorator';
import Vue, { PropType } from 'vue';
import CSelectButtons, {
  CSelectButtonsPropsItems,
} from '@/components/Helper/Form/CSelectButtons.vue';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';

@Component<CPointSelect>({
  components: { CSelectButtons },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class CPointSelect extends Vue {
  currentStaff!: StaffEntity;

  @Prop({ type: Number, required: false })
  value: number;

  @Prop({ type: Array as PropType<string[]>, required: false })
  errors: string[];

  get pointOptionList(): CSelectButtonsPropsItems[] {
    return this.currentStaff.defaultGiftPoint.map((pt) => ({
      value: pt,
      text: `${pt}pt`,
    }));
  }
}
